import { factory, am } from './utils';

import httpClient from '@/utils/httpClient';

const DOCKETING_LOAD_STREAM = am(`DOCKETING_LOAD_STREAM`);

export default {
  namespaced: true,
  ...factory(
    {
      state: {
        id: null,
        total: 0,
        from: 0,
        data: [],
        isRequestPending: false,
        isRequestFailed: true,
        isMoreRequestPending: false
      },
      getters: {
        collection: state => {
          return state.data.sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
        }
      },
      mutations: {
        [DOCKETING_LOAD_STREAM.STARTED](state, { id, initialize }) {
          state.id = id;
          state.isRequestFailed = false;
          if (initialize) {
            state.isRequestPending = true;
            state.data = [];
          } else {
            state.isMoreRequestPending = true;
          }
        },
        [DOCKETING_LOAD_STREAM.COMPLETED](state, { data, total }) {
          for (const item of data) {
            if (state.data.find(({ id }) => item.id === id)) {
              continue;
            }
            state.data.unshift(item);
          }

          state.total = total;
          state.isRequestPending = false;
          state.isMoreRequestPending = false;
        },
        [DOCKETING_LOAD_STREAM.FAILED](state) {
          state.isRequestPending = false;
          state.isRequestFailed = true;
        }
      },
      actions: {
        async load({ commit }, { id, skip, from, to }) {
          try {
            commit(DOCKETING_LOAD_STREAM.STARTED, {
              id,
              initialize: typeof skip === 'undefined'
            });

            const params = new URLSearchParams();
            if (skip) {
              params.set('skip', skip);
            }
            if (from) {
              params.set('from', from);
            }
            if (to) {
              params.set('to', to);
            }

            params.set('size', 25);

            const response = await httpClient.get(`/api/streams/events/${id}/docketing?${params.toString()}`);

            commit(DOCKETING_LOAD_STREAM.COMPLETED, {
              data: response.data.map(item => ({ ...item, createdAt: new Date(item.createdAt) })),
              total: response.total
            });
          } catch (e) {
            commit(DOCKETING_LOAD_STREAM.FAILED);
            throw e;
          }
        },
        'stream:added'({ commit, state }, item) {
          commit(DOCKETING_LOAD_STREAM.COMPLETED, {
            data: [{ ...item, createdAt: new Date(item.createdAt) }].filter(
              item => item.inventionId === state.id && item.type?.startsWith('docketing-')
            ),
            total: state.total + 1
          });
        }
      }
    },
    {
      path: '/api/streams/socket.io',
      actions: {
        subscribe: 'join',
        unsubscribe: 'leave'
      },
      handlers: ['stream:added']
    }
  )('EMAILs', {
    async getCollection() {
      throw new Error('Not implemented.');
    },
    async create() {
      throw new Error('Not implemented.');
    },
    async delete() {
      throw new Error('Not implemented.');
    },
    async update() {
      throw new Error('Not implemented.');
    }
  })
};
